import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { BookingPackageType, BookingProductType } from '@products/models/booking.model';
import { ProductList, SendingOptionModel } from '@products/models/product-selection.model';
import { VoucherCode } from '@products/models/voucher.model';

export const ProductSelectionActions = createActionGroup({
  source: 'Product Selection',
  events: {
    'Set initial product selection list': (products: ProductList) => ({ products }),
    'Set preferred product selection list': (products: ProductList) => ({ products }),
    'Set voucher product in selection list': props<{
      bookingProductTypes: BookingProductType[];
      isSelfRegistration: boolean;
    }>(),
    'Remove voucher product from selection list': (removeBookedVoucherProducts: BookingProductType[]) => ({
      payload: removeBookedVoucherProducts
    }),
    'Remove voucher code product from selection list': (voucherCode: VoucherCode) => ({
      payload: voucherCode
    }),
    'Set package in selection list': (bookedPackageTypes: BookingPackageType[]) => ({ bookedPackageTypes }),
    'Remove package from selection list': (bookedPackageTypes: BookingPackageType[]) => ({ bookedPackageTypes }),
    'Reset reducer': emptyProps()
  }
});

export const SendingOptionActions = createActionGroup({
  source: 'Sending Options',
  events: {
    'Init sending options': (sendingOptions: SendingOptionModel[]) => ({ sendingOptions }),
    'Set sending options': (sendingOptions: SendingOptionModel[]) => ({ sendingOptions })
  }
});
